// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_k2-1";
export var rowFirst = "_k2-3";
export var rowLast = "_k2-5";
export var rowMiddle = "_k2-4";
export var ticketListScroll = "_k2-2";
export var ticketStack = "_k2-0";